import { ChecklightSessionStatus } from '@thesavingsgroup/enums/ChecklightSessionStatus';

export const FAILED_TASK_STATUSES: string[] = [
  ChecklightSessionStatus.FAILED_SUBMISSION,
];
